import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import configs from "./modules/configs";
import errors from "./modules/errors";
import misc from "./modules/misc";
import overlay from "./modules/overlay";
import snackbar from "./modules/snackbar";
import validation from "./modules/validation";
import cart from "./modules/cart";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
        configs,
        errors,
        misc,
        overlay,
        snackbar,
        validation,
        cart,
    },
});

export default store;
